import { Button } from '@kcftech/design-system';
import { IUserContext } from 'contexts/UserContext';
import { usePopup } from 'custom_hooks/usePopup';
import { logout } from 'pages/Login/Login';
import { TriggeredPopup } from 'shared/triggered_popup/TriggeredPopup';
import styled from 'styled-components';

export type UserMenuOptionsProps = Readonly<{
    userContext: IUserContext;
    onChangePasswordClick: () => void;
}>;

const UserMenuOptionsContainer = styled.div`
    justify-content: space-between;
`;

const UserMenuOption = styled.div`
    display: flex;
`;

export function UserMenuOptions({
    userContext,
    onChangePasswordClick,
}: UserMenuOptionsProps) {
    const {
        isOpen,
        close,
        toggleOpen,
        popupRef,
        triggerRef: logoutButtonRef,
    } = usePopup();
    return (
        <UserMenuOptionsContainer className="flex-row">
            {!userContext.user?.IdentityProviderName && (
                <UserMenuOption>
                    <Button
                        appearance="secondary"
                        spacing="compact"
                        onClick={onChangePasswordClick}
                        type="submit"
                    >
                        Change Password
                    </Button>
                </UserMenuOption>
            )}
            <UserMenuOption>
                <Button
                    spacing="compact"
                    onClick={toggleOpen}
                    type="submit"
                    ref={logoutButtonRef}
                >
                    Log Off
                </Button>
                {isOpen && (
                    <TriggeredPopup
                        anchorRef={logoutButtonRef}
                        ref={popupRef}
                        onClose={close}
                        test-id={'logout-type-popup'}
                    >
                        <div className="flex flex-column gap-10">
                            <Button
                                spacing="compact"
                                onClick={() => logout(false)}
                                type="submit"
                                appearance="secondary"
                            >
                                Log Off in this Browser
                            </Button>
                            <Button
                                spacing="compact"
                                onClick={() => logout(true)}
                                type="submit"
                                appearance="secondary"
                            >
                                Log Off Everywhere
                            </Button>
                        </div>
                    </TriggeredPopup>
                )}
            </UserMenuOption>
        </UserMenuOptionsContainer>
    );
}
